import script from "./UModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UModal.vue?vue&type=script&setup=true&lang=js"

import "./UModal.vue?vue&type=style&index=0&id=8d5dc85c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d5dc85c"]])

export default __exports__